import { AbstractControl, ValidatorFn } from '@angular/forms';

export function passwordFerozo(excludeSepecialChars?: boolean): ValidatorFn {
    const checkMayus: RegExp = new RegExp(/[A-Z]/);
    const checkMinus: RegExp = new RegExp(/[a-z]/);
    const checkNumber: RegExp = new RegExp(/[0-9]/);
    // const checkSpecialCharacters: RegExp = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/);

    // Con esta expresión regular, coincidirá con cualquier cadena que contenga
    // al menos uno de los caracteres @, *, o /.
    // const checkSpecialCharacters: RegExp = new RegExp(/[@*\/]+/);

    // La expresión acepta al menos uno de los caracteres @, /, o *
    /** 
     * ^[^!#$%^&*()_+|~={}:";'<>?,./\]*` permite cero o más caracteres que no estén en el conjunto especificado al principio de la cadena.
     * [@*\/] coincide con al menos uno de los caracteres @, / o *.
     * [^!#$%^&*()_+|~={}:";'<>?,./\]*$` permite cero o más caracteres que no estén en el conjunto especificado al final de la cadena.

        Esto garantiza que la cadena tenga al menos uno de los caracteres permitidos (@, /, o *).
    */
    const checkSpecialCharacters: RegExp =
        /^[^!#$%^&()_+|~=`{}\[\]:";'<>?,.\\]*[@*\/][^!#$%^&()_+|~=`{}\[\]:";'<>?,.\\]*$/;

    const passwordConsecutiveNumbers: RegExp = new RegExp(/(012|123|234|345|456|567|678|789)/);

    return (control: AbstractControl): { [key: string]: any } | null => {
        const valid =
            checkNumber.test(control.value) &&
            !passwordConsecutiveNumbers.test(control.value) &&
            checkMayus.test(control.value) &&
            checkMinus.test(control.value) &&
            (excludeSepecialChars ?? checkSpecialCharacters.test(control.value));

        return valid
            ? null
            : {
                  validators: {
                      checkMayus: !checkMayus.test(control.value),
                      checkMinus: !checkMinus.test(control.value),
                      checkNumber: !checkNumber.test(control.value),
                      checkSpecialCharacters: !checkSpecialCharacters.test(control.value),
                      consecutiveNumbers: control.value !== '' ? passwordConsecutiveNumbers.test(control.value) : true,
                  },
              };
    };
}
